module.exports = __webpack_public_path__ + "img/icon_xinjianwenjianjia.6f2d0edc.svg";